<script>
import baseMixin from '@/mixins/baseMixin'
import UserAvatar from '@/components/user/user-avatar.vue'
import BookingConfirmationsListItemEditForm from '@/components/booking/booking-confirmations-list-item-edit-form.vue'

export default {
  name: 'BookingConfirmationsListItem',
  components: { UserAvatar, BookingConfirmationsListItemEditForm },
  mixins: [baseMixin],
  props: {
    confirmation: {
      type: Object,
      required: true,
    },
    confirmations: {
      type: Array,
      required: true,
    },
    contacts: {
      type: Array,
      required: true,
    },
    create: {
      type: Boolean,
    },
  },
  data: () => {
    return {
      showEditForm: false,
    }
  },
  computed: {
    getContact() {
      return this.contacts.find((x) => x.id === this.confirmation.contactId)
    },
    smsDetails() {
      if (!this.confirmation.sms) return null
      const contact = this.getContact
      if (!contact) return null
      return contact[this.confirmation.sms.toLowerCase()]
    },
    voiceDetails() {
      if (!this.confirmation.voice) return null
      const contact = this.getContact
      if (!contact) return null
      return contact[this.confirmation.voice.toLowerCase()]
    },
    emailDetails() {
      if (!this.confirmation.email) return null
      const contact = this.getContact
      if (!contact) return null
      return contact.emailAddress
    },
  },
  methods: {
    remove(id) {
      this.$emit('remove', id)
    },
    save(payload) {
      this.$emit('save', payload)
    },
    close() {
      if (this.create) return this.$emit('closeForm')
      this.showEditForm = false
    },
  },
}
</script>

<template>
  <v-card class="custom-elevation rounded-xl">
    <v-expand-transition>
      <v-list
        v-if="!showEditForm && !create"
        class="booking-confirmations-list__details-list"
        two-line
      >
        <v-list-item class="align-center">
          <v-list-item-avatar>
            <UserAvatar :name="confirmation.fullName" size="md" />
          </v-list-item-avatar>
          <v-list-item-content>
            <div class="booking-confirmations-list-item__full-name body-2">
              {{ confirmation.fullName }}
            </div>
            <v-list-item-subtitle class="caption">
              <v-tooltip v-if="emailDetails" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="booking-confirmations-list-item__email-icon"
                    small
                    icon
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon small>mdi-email</v-icon>
                  </v-btn>
                </template>
                <span>
                  {{
                    $t('bookingCreate.confirmationsEmailTooltip', {
                      email: emailDetails,
                    })
                  }}
                </span>
              </v-tooltip>
              <v-tooltip v-if="voiceDetails" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="booking-confirmations-list-item__voice-icon"
                    small
                    icon
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon small>mdi-phone</v-icon>
                  </v-btn>
                </template>
                <span>
                  {{
                    $t('bookingCreate.confirmationsVoiceTooltip', {
                      voice: voiceDetails,
                    })
                  }}
                </span>
              </v-tooltip>

              <v-tooltip v-if="smsDetails" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="booking-confirmations-list-item__sms-icon"
                    small
                    icon
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon small>mdi-message-text</v-icon>
                  </v-btn>
                </template>
                <span>
                  {{
                    $t('bookingCreate.confirmationsSMSTooltip', {
                      sms: smsDetails,
                    })
                  }}
                </span>
              </v-tooltip>
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="booking-confirmations-list-item__edit-btn"
                  icon
                  v-bind="attrs"
                  @click="showEditForm = true"
                  v-on="on"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('bookingCreate.confirmationsEditBtn') }}</span>
            </v-tooltip>
          </v-list-item-action>
          <v-list-item-action>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="booking-confirmations-list-item__remove-btn"
                  icon
                  v-bind="attrs"
                  @click="remove(confirmation.contactId)"
                  v-on="on"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('bookingCreate.confirmationsRemoveBtn') }}</span>
            </v-tooltip>
          </v-list-item-action>
        </v-list-item>
      </v-list>
      <BookingConfirmationsListItemEditForm
        v-else
        class="booking-confirmations-list__list-item-edit-form"
        :confirmation="confirmation"
        :confirmations="confirmations"
        :contacts="contacts"
        @save="save"
        @close="close"
      />
    </v-expand-transition>
  </v-card>
</template>
